/* eslint-disable no-useless-escape */
import React, { useState } from 'react'
import { InView } from 'react-intersection-observer'
import fetch from 'isomorphic-unfetch'

import { gethostPath } from '../../helpers/ContentHelper'
import PromotionPanel from '../PromotionPanel/PromotionPanel'

const Recommendations = () => {
  const [recommendationsData, setRecommendationsData] = useState()
  const [productsData, setProductsData] = useState()
  const [gettingData, nowGettingData] = useState(false)
  const RecommendationData = {
    error: false,
    loading: !productsData,
    products: productsData,
  }

  const fetchProductData = async () => {
    if (recommendationsData && recommendationsData.data) {
      const partNumbers = recommendationsData.data.map((product) => product.id)
      Promise.all(partNumbers.map((product) => fetch(`${gethostPath()}global-api/products/partNumber=${product}`)))
        .then((groupedResponse) =>
          Promise.all(
            groupedResponse.map((response) =>
              response
                .json()
                .then((dataTest) =>
                  dataTest?.data?.data ? { ...dataTest.data.data, included: dataTest.data.included } : null,
                ),
            ),
          ),
        )
        .then((finalData) => {
          setProductsData(finalData)
        })
        .catch((error) => console.error(error))
    }
  }

  const getProducts =
    recommendationsData && recommendationsData.data && typeof productsData === 'undefined' && fetchProductData()

  const fetchRecommendationsData = async () => {
    const AMCV_MATCH = decodeURI(JSON.stringify(/AMCV_[0-9A-Z\%]+AdobeOrg=([0-9a-zA-Z\%\-\_]+)/g.exec(document.cookie)))
    const VISITOR_ID = AMCV_MATCH?.split('MCMID|')[1]?.split('|')[0]
    const url = `${gethostPath()}recommendations-api?channel=homepage&placement=welcomeback&visitorId=${VISITOR_ID}&trackingId=${VISITOR_ID}`

    let resData
    const res = await fetch(url)
    try {
      resData = await res.json()
      setRecommendationsData(resData)
      getProducts()
    } catch (err) {
      resData = {}
    }
  }

  const getData = () => {
    if (!gettingData) {
      nowGettingData(true)
      fetchRecommendationsData()
    }
  }

  const isTrending = recommendationsData?.data[0]?.type === 'trending'
  const title = !recommendationsData ? '' : isTrending ? 'Everybody loves these...' : 'Your recently viewed products...'

  const tracking = {
    pageCategory: 'HP',
    mvts: recommendationsData?.meta?.mvts[0]?.variantId,
    onLoad: {
      eventName: 'hp_recommendationsLoaded',
      eventAction: 'Recommendations Loaded',
    },
    onView: {
      eventName: 'hp_recommendationsViewed',
      eventAction: 'Recommendations Viewed',
    },
    onSlideChange: {
      eventName: 'hp_recommendationsNewPageViewed',
      eventAction: 'Recommendations New Page Viewed',
    },
  }

  return (
    <InView onChange={(inView) => inView && !recommendationsData && !recommendationsData?.data && getData()}>
      <PromotionPanel
        data={RecommendationData}
        dataTest='everybody-loves'
        section='bottomSlider'
        source={isTrending ? 'trending' : 'recently'}
        title={title}
        tracking={tracking}
      />
    </InView>
  )
}

export default Recommendations
